import config from "config";

const BOTXO_DEV_DOMAIN = "https://t.botxo.co";
const CERTAINLY_DEV_DOMAIN = "https://dev.certainly.ai";

const domainPattern = /(botxo\.co)/;

export const isBotxoDomain = () => {
  const { domain } = config;

  const hostName = window && window.location && window.location.hostname;
  const currentDomain = hostName || domain;

  return !!currentDomain && !!currentDomain.match(domainPattern);
};

export const getStylesFromDomain = (prevStyles, newStyles) => {
  if (prevStyles && newStyles) {
    const isPrevDomain = isBotxoDomain();

    return isPrevDomain ? prevStyles : newStyles;
  }
  return prevStyles || newStyles || undefined;
};

export const getDomain = () => {
  const hostName = window && window.location && window.location.hostname;
  const isPrevDomain = isBotxoDomain();

  let domain = window && window.location && window.location.origin;
  if (hostName === "localhost") {
    domain = isPrevDomain ? BOTXO_DEV_DOMAIN : CERTAINLY_DEV_DOMAIN;
  }

  return domain;
};
